// extracted by mini-css-extract-plugin
module.exports = {"container":"vB","productName":"wB","modal":"xB","dimensions":"yB","recipientEmail":"zB","lowStock":"AB","recommendedFit":"BB"};